export const lowerCaseRegex = /[a-z]/;
export const upperCaseRegex = /[A-Z]/;
export const digitRegex = /\d/;
export const specialCharRegex = /[!@#$%^&*]/;
export const passwordStrengthRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/;
